import { useCallback, useMemo } from 'react'

import { RootState } from '@editor/store/app'
import { useSelector } from 'react-redux'

const useDrawingStateCheck = () => {
  // Store
  const workingElementId = useSelector((state: RootState) => state.toolUtil.core.workingElementId)
  const editingElementId = useSelector((state: RootState) => state.toolUtil.core.editingElementId)

  // Vars
  const isAnyAdjusting = useMemo(() => !!workingElementId || !!editingElementId, [workingElementId, editingElementId])

  const isWorking = useCallback((elementId: string) => elementId === workingElementId, [workingElementId])

  /**
   * Check if the given element ID is currently being adjusted (either worked on or edited).
   */
  const isAdjusting = useCallback(
    (elementId: string) => elementId === workingElementId || elementId === editingElementId,
    [workingElementId, editingElementId],
  )

  /**
   * Check if the given element ID is selectable (i.e., either no element is being worked on or it's the one being worked on).
   */
  const isSelectable = useCallback(
    (elementId: string) => !workingElementId || elementId === workingElementId,
    [workingElementId],
  )

  return {
    workingElementId,
    editingElementId,
    isAnyAdjusting,
    isWorking,
    isAdjusting,
    isSelectable,
  }
}

export default useDrawingStateCheck
